import React from "react";

/*
    The API access status pill.

    Lifted out of ApiAccess.js unchanged — same statuses, same tones, same
    .api-access__badge--* classes already in pages.scss — because the account
    navigation now shows it beside the "API Management" label, and the page
    still shows it beside its own heading. One definition, two callers.
*/
const TONES = {
  active: "success",
  pending: "info",
  suspended: "warning",
  revoked: "muted",
  failed: "danger",
};

const LABELS = {
  none: "Not set up",
  pending: "Setting up",
  active: "Active",
  suspended: "Suspended",
  revoked: "Revoked",
  failed: "Setup failed",
};

const ApiStatusBadge = ({ status, className = "" }) => (
  <span
    className={`api-access__badge api-access__badge--${
      TONES[status] || "muted"
    } ${className}`}
  >
    {LABELS[status] || "Unknown"}
  </span>
);

export default ApiStatusBadge;
